import React from 'react';
import { Row, Col, Accordion } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import DetailImage from '../../assets/images/details.png';
import Header from '../Header/Header';

import "./ifo.css";

function Ifo() {
	return (
		<div>
			<Header />
			<div className="ifo content-section">
				<div className="container">
					<div className="ifo-bg mb-5">
						<div className="heading-section">
							<div className="main-bg-content text-center">
								<h1>How to Take Part</h1>
							</div>
						</div>
						<div className="steps-holder position-relative">
							<Row>
								<Col lg={6} className="d-flex position-relative">
									<div className="activate-profile-content-info">
										<span className="numbers-tags">1</span>
										<h2 className="all-h2 mb-3">Activate your Profile</h2>
										<p className="all-p">You’ll need an active PanCardanoSwap Profile to take part in an IFO!</p>
										<div className="activate-profile-content-button">
											<button className="btn all-btns">Connect Wallet</button>
										</div>
									</div>
								</Col>
							</Row>
							<Row>
								<Col lg={6} className="d-flex position-relative">
									<div className="activate-profile-content-info">
										<span className="numbers-tags">2</span>
										<h2 className="all-h2 mb-3">Get Cardano-BNB LP Tokens</h2>
										<p className="all-p">Stake Cardano and BNB in the liquidity pool to get LP tokens.You’ll spend them to buy IFO sale tokens.</p>
										<div className="activate-profile-content-button">
											<button className="btn all-btns">Get LP tokens</button>
										</div>
									</div>
								</Col>
							</Row>
							<Row>
								<Col lg={6} className="d-flex position-relative">
									<div className="activate-profile-content-info">
										<span className="numbers-tags">3</span>
										<h2 className="all-h2 mb-3">Commit LP Tokens</h2>
										<p className="all-p mb-0">When the IFO sales are live, you can “commit” your LP tokens to buy the tokens being sold.</p>
										<p className="all-p">We recommend committing to the Basic Sale first, but you can do both if you like.</p>
									</div>
								</Col>
							</Row>
							<Row>
								<Col lg={6} className="d-flex position-relative">
									<div className="activate-profile-content-info">
										<span className="numbers-tags">4</span>
										<h2 className="all-h2 mb-3">Commit LP Tokens</h2>
										<p className="all-p">After the IFO sales finish, you can claim any IFO tokens that you bought, and any unspent Cardano-BNB LP tokens will be returned to your wallet.</p>
									</div>
								</Col>
							</Row>
						</div>
					</div>
					<div className="details">
						<div className="row">
							<div className="col-lg-5 d-flex justify-content-center">
								<div className="details-img mb-4 mb-lg-0">
									<img src={DetailImage} className="img-fluid" />
								</div>
							</div>
							<div className="col-lg-7">
								<div className="accordion-area">
									<div className="heading-section">
										<h2>Details</h2>
									</div>
									<Accordion>
										<Accordion.Item eventKey="0">
											<Accordion.Header>
												<h2>What’s the difference between a Basic Sale and Unlimited Sale?</h2>
												<span className="toggle-text">
													<span className="detail-text">Details</span>
													<span className="hide-text">Hide</span>
													<FontAwesomeIcon icon={faAngleDown} className="down-icon"/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>
												<h2>Which sale should I commit to? Can I do both?</h2>
												<span className="toggle-text">
													<span className="detail-text">Details</span>
													<span className="hide-text">Hide</span>
													<FontAwesomeIcon icon={faAngleDown} className="down-icon"/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>
												<h2>How much is the participation fee?</h2>
												<span className="toggle-text">
													<span className="detail-text">Details</span>
													<span className="hide-text">Hide</span>
													<FontAwesomeIcon icon={faAngleDown} className="down-icon"/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>
												<h2>Where does the participation fee go?</h2>
												<span className="toggle-text">
													<span className="detail-text">Details</span>
													<span className="hide-text">Hide</span>
													<FontAwesomeIcon icon={faAngleDown} className="down-icon"/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>
												<h2>Hpw can I get an achievement for participating in the Ifo?</h2>
												<span className="toggle-text">
													<span className="detail-text">Details</span>
													<span className="hide-text">Hide</span>
													<FontAwesomeIcon icon={faAngleDown} className="down-icon"/>
												</span>
											</Accordion.Header>
											<Accordion.Body>
												<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate.</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Ifo;